// extracted by mini-css-extract-plugin
export default {"container":"telestration-actions_container__mPDBQ"};